/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    object, func, string, number, shape, arrayOf,
} from 'prop-types';
import { bindActionCreators } from 'redux';
import ReactHtmlParser from 'react-html-parser';
import { uid } from 'react-uid';
import Slider from 'react-slick';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import Link from '@material-ui/core/Link';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import Typography from '@material-ui/core/Typography';
import ItemImage from '../../../ItemImage/ItemImage';
import { addToCartFood } from '../../../../../../../../../../state/ducks/Checkout/ducks/Checkout/Checkout-Actions';

const styles = ({ palette }) => ({
    recommendationItemInfo: {
        marginLeft: '12px',
        wordBreak: 'break-word',
        width: '65%',
        '& a, p': {
            fontSize: '15px',
        },
        '& a': {
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
        },
        '& button': {
            width: '98px',
            padding: '0px',
            fontSize: '12px',
            fontWeight: '700',
            border: `1px solid ${palette.grey5 || '#909090'}`,
            borderRadius: '4px',
            height: '27px',
            background: (palette.primary?.contrastText || '#fff'),
            marginTop: '24px',
            '&:hover': {
                backgroundColor: (palette.secondary?.main || '#a1001a'),
                color: (palette.primary?.contrastText || '#fff'),
            },
        },
    },
});

const UpSellProductList = ({
    classes,
    actionAddToCartFood,
    product,
    history,
}) => {
    if (!product) return null;

    const salePriceFilter = (price) => (price?.filter((priceObj) => priceObj?.type === 'sale')[0]);

    const productPriceFilter = (price = []) => {
        const salePrice = salePriceFilter(price);
        return (`$${(salePrice?.value || '0')}`);
    };

    const addUpsellsToCart = (upsellItem) => {
        if (upsellItem?.id === '') return null;

        const reqObj = {
            brandCode: upsellItem.brandId,
            productCode: upsellItem.id,
            quantity: 1,
            attributes: [],
        };

        return actionAddToCartFood(reqObj, history, upsellItem.id, null, null, null, true);
    };

    return (
        <Slider
            className="carousel-container"
            dots={false}
            infinite={false}
            speed={500}
            slidesToShow={2}
            slidesToScroll={2}
            arrows
            nextArrow={<ArrowForwardIosIcon />}
            prevArrow={<ArrowBackIosIcon />}
        >
            {product.map((upsellItem, index) => (
                <div key={uid(upsellItem, index)}>
                    <Grid container>
                        <Grid>
                            <ItemImage
                                imagePath={upsellItem?.image?.path || ''}
                                imageName={upsellItem?.image?.name || ''}
                                typeImg="x"
                            />
                        </Grid>
                        <Grid className={classes.recommendationItemInfo}>
                            <Link href={upsellItem?.parentProduct?.seo?.url} className="line-clamp-2">
                                {ReactHtmlParser(upsellItem?.name)}
                            </Link>
                            <Typography variant="body2">
                                <b>{productPriceFilter(upsellItem.prices)}</b>
                            </Typography>
                            <Button
                                className={classes.selectView}
                                onClick={() => addUpsellsToCart(upsellItem)}
                                data-testid={`upsells-addcart-${index}`}
                            >
                                Add to cart
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            ))}
        </Slider>
    );
};

UpSellProductList.propTypes = {
    classes: object.isRequired,
    product: arrayOf(shape({
        brandId: string.isRequired,
        id: string.isRequired,
        image: shape({
            name: string.isRequired,
            path: string.isRequired,
        }).isRequired,
        prices: arrayOf(shape({
            type: string.isRequired,
            value: number.isRequired,
        })).isRequired,
    })).isRequired,
    history: object.isRequired,
    actionAddToCartFood: func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
    actionAddToCartFood: bindActionCreators(addToCartFood, dispatch),
});

const enhance = compose(
    connect(null, mapDispatchToProps),
    withRouter,
    withStyles(styles),
);

export default enhance(UpSellProductList);
